import { createSlice } from "@reduxjs/toolkit"
import { fetchTodos, userLogin } from "./loginActions"

let user_LS
let resources_LS
let user_profile
if (typeof localStorage !== `undefined`) {
    user_LS = JSON.parse(localStorage.getItem("user"))
    resources_LS = JSON.parse(localStorage.getItem("resources"))
    user_profile = JSON.parse(localStorage.getItem("userProfile"))
    // console.log("usr from LS reducer", JSON.parse(localStorage.getItem("user")))
}

let user_auth_LS
if (typeof localStorage !== `undefined`) {
    user_auth_LS = JSON.parse(localStorage.getItem("userAuth"))
}

let user_location_LS
if (typeof localStorage !== `undefined`) {
    user_location_LS = JSON.parse(localStorage.getItem("userLocation"))
}

var login_tracker_LS
if (typeof localStorage !== `undefined`) {
    login_tracker_LS = JSON.parse(localStorage.getItem("loginTracker"))
}

let org = user_LS?.organizationListForUser?.[0]

const now = new Date()

// Calculate the difference in milliseconds
const diffInMs = org ? now - new Date(org?.created_date) : 0

// Convert milliseconds to days
const diffInDays = diffInMs / (1000 * 60 * 60 * 24)

// Check if 7 days have passed
const hasSevenDaysPassed = diffInDays >= 90

console.log(
    org,
    org?.created_date,
    diffInMs,
    diffInDays,
    hasSevenDaysPassed,
    "klsdjfdsfjlkdsfjs"
)

let subscriptionDetails = {
    isFreeTrial: false,
    subscription: org?.stripe_sub_id || false,
}

let alertState = {
    open: false,
    vertical: "top",
    horizontal: "center",
    duration: 6000,
    type: "success",
    variant: "filled",
    message: "",
}

const initialState = {
    loading: false,
    loggedin: false,
    user: user_LS || {},
    error: "",
    auth: user_auth_LS || {},
    tokenRefreshed: false,
    resources: resources_LS || [],
    userLocation: user_location_LS || {},
    data: [],
    languages: [],
    timeZones: [],
    userProfile: user_profile || {},
    schedule: {},
    blockoutDays: [],
    associatedClinics: [],
    alert: alertState,
    loginTracker: login_tracker_LS || {},
    refetchingToken: false,
    receivedNotification: false,
    updatingToken: false,
    settimeoutObject: null,
    subscriptionDetails,
    activityCategories: [],
    activityTracker: null,
    profileImageUrl: null,
}

const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        loginRequest: (state, action) => {
            state.loading = true
        },
        loginSuccess: (state, action) => {
            console.log(action.payload, "lkfjsdljflsfj")
            localStorage.setItem("user", JSON.stringify(action.payload))
            localStorage.setItem(
                "userProfile",
                JSON.stringify(action.payload.profileForUser[0])
            )
            state.loading = false
            state.loggedin = true
            state.user = action.payload
            state.userProfile = action.payload.profileForUser[0]
        },
        loginFailure: (state, action) => {
            state.loading = false
            state.user = {}
            state.error = action.payload
        },
        logoutAction: (state, action) => {
            localStorage.setItem("user", JSON.stringify({}))
            localStorage.setItem("resources", JSON.stringify([]))
            localStorage.setItem("userAuth", JSON.stringify([]))
            localStorage.setItem("userLocation", JSON.stringify([]))
            localStorage.setItem("userProfile", JSON.stringify({}))
            localStorage.setItem("patientDetails", JSON.stringify({}))
            localStorage.removeItem("organization")
            localStorage.removeItem("clinic")
            localStorage.removeItem("clinicsList")
            localStorage.removeItem("organizationsList")
            state.user = {}
            state.loading = false
            state.loggedin = false
            state.error = ""
        },
        updateAuth: (state, action) => {
            localStorage.setItem("userAuth", JSON.stringify(action.payload))
            state.auth = action.payload
        },
        updateTokenRefreshed: (state, action) => {
            state.tokenRefreshed = action.payload
        },
        updateResources: (state, action) => {
            state.resources = action.payload
        },
        updateUserLocation: (state, action) => {
            state.userLocation = action.payload
        },
        updateLanguages: (state, action) => {
            state.languages = action.payload
        },
        updateTimeZones: (state, action) => {
            state.timeZones = action.payload
        },
        updateUserProfile: (state, action) => {
            state.userProfile = action.payload
        },
        updateSchedule: (state, action) => {
            state.schedule = action.payload
        },
        updateBlockoutDays: (state, action) => {
            state.blockoutDays = action.payload
        },
        associatedClinicsUsers: (state, action) => {
            state.associatedClinics = action.payload
        },
        updateAlert: (state, action) => {
            state.alert = action.payload
        },
        updateLoading: (state, action) => {
            state.loading = action.payload
        },
        updateLoginTracker: (state, action) => {
            localStorage.setItem("loginTracker", JSON.stringify(action.payload))
            state.loginTracker = action.payload || {}
        },
        refetchingToken: (state, action) => {
            state.refetchingToken = action.payload
        },
        updateReceivedNotification: (state, action) => {
            state.receivedNotification = action.payload
        },
        updateCoachMarks: (state, action) => {
            state.loginTracker.userProfile = state.loginTracker.userProfile
                ? { ...state.loginTracker.userProfile, coachMark: true }
                : { coachMark: true }
        },
        updateUpdatingToken: (state, action) => {
            state.updatingToken = action.payload
        },
        updateSettimeoutObject: (state, action) => {
            state.settimeoutObject = action.payload
        },
        updateLoggedIn: (state, action) => {
            state.loggedin = action.payload
        },
        updateSubscriptionDetails: (state, action) => {
            console.log(action.payload, "klsfjldjfdsfdjfjsdl")
            state.subscriptionDetails = action.payload
        },
        updateActivityCategories: (state, action) => {
            state.activityCategories = action.payload
        },
        updateActivtyTracker: (state, action) => {
            state.activityTracker = action.payload
        },
        updateProfileImageUrl: (state, action) => {
            state.profileImageUrl = action.payload
        },
    },
})

export const {
    updateSubscriptionDetails,
    loginRequest,
    loginSuccess,
    loginFailure,
    logoutAction,
    updateAuth,
    updateTokenRefreshed,
    updateResources,
    updateUserLocation,
    updateLanguages,
    updateTimeZones,
    updateUserProfile,
    updateSchedule,
    updateBlockoutDays,
    associatedClinicsUsers,
    updateAlert,
    updateLoading,
    updateLoginTracker,
    refetchingToken,
    updateReceivedNotification,
    updateCoachMarks,
    updateUpdatingToken,
    updateSettimeoutObject,
    updateLoggedIn,
    updateActivityCategories,
    updateActivtyTracker,
    updateProfileImageUrl,
} = loginSlice.actions

export default loginSlice.reducer
